import { createAction, props } from '@ngrx/store';
import { AuditLog } from '@shared/models/audit-log.model';
import { Pagination } from '@shared/models/pagination.model';

import {
  SupplierPartnerCouponContent,
  SupplierPartnerCouponCriteria,
  SupplierPartnerCouponPagination,
  SupplierPartnerCouponProduct
} from '../models/supplier-partner-coupon.model';

export const supplierPartnerCouponClearSate = createAction('[Supplier Partner Coupon] Clear State');
export const supplierPartnerCouponListRequest = createAction(
  '[Supplier Partner Coupon] Supplier Partner Coupon List Request',
  props<{
    payload: SupplierPartnerCouponCriteria;
  }>()
);

export const supplierPartnerCouponListResponse = createAction(
  '[Supplier Partner Coupon] Supplier Partner Coupon List Response',
  props<{ response: SupplierPartnerCouponPagination }>()
);

export const supplierPartnerCouponViewRequest = createAction(
  '[Supplier Partner Coupon] Supplier Partner Coupon View Request',
  props<{
    offerCampaignNo: string;
    redeemCampaignNo: string;
  }>()
);
export const supplierPartnerCouponViewResponse = createAction(
  '[Supplier Partner Coupon] Supplier Partner Coupon View Response',
  props<{ response: SupplierPartnerCouponContent }>()
);

export const supplierPartnerCouponHistoryRequest = createAction(
  '[Supplier Partner Coupon] Supplier Partner Coupon History Request',
  props<{
    offerCampaignNo: string;
    redeemCampaignNo: string;
  }>()
);

export const supplierPartnerCouponHistoryResponse = createAction(
  '[Supplier Partner Coupon] Supplier Partner Coupon History Response',
  props<{ response: AuditLog[] }>()
);

export const supplierPartnerCouponProductRequest = createAction(
  '[Supplier Partner Coupon] Supplier Partner Coupon Product Request',
  props<{
    payload: { type: string; campaignNo: string; usage: string; pageNo: number; pageSize: number };
  }>()
);

export const supplierPartnerCouponProductResponse = createAction(
  '[Supplier Partner Coupon] Supplier Partner Coupon Product Response',
  props<{
    response: Pagination<SupplierPartnerCouponProduct>;
    usage: string;
  }>()
);
